import { useMutation, useQuery } from '@apollo/client';

import { FORM_COMPLETION_ANSWERS } from 'kb-shared/graphql/queries';
import { BugTracker } from 'kb-shared/utilities/bugTracker';

import {
  FormCompletionQueryArguments,
  FormCompletionQueryResponse
} from '../graphql/form-completion-query';
import {
  SaveFormAnswerMutationArguments,
  SaveFormAnswerMutationResponse,
  SAVE_FORM_ANSWER_MUTATION
} from '../graphql/save-form-answer-mutation';

export const useRiskAssessmentAnswers = (
  formId: number
): {
  answerByFieldId: Record<string, boolean>;
  saveAnswer: (formFieldId: number, answer: boolean) => Promise<any>;
} => {
  const formCompletionVariables = { formId };

  const { data } = useQuery<FormCompletionQueryResponse, FormCompletionQueryArguments>(
    FORM_COMPLETION_ANSWERS,
    {
      variables: formCompletionVariables,
      onError: error => BugTracker.notify(error, 'RiskAssessmentLoadingAnswers')
    }
  );

  const [saveAnswerMutation] = useMutation<
    SaveFormAnswerMutationResponse,
    SaveFormAnswerMutationArguments
  >(SAVE_FORM_ANSWER_MUTATION, {
    refetchQueries: [{ query: FORM_COMPLETION_ANSWERS, variables: formCompletionVariables }],
    onError: error => BugTracker.notify(error, 'RiskAssessmentSaveAnswer')
  });

  const saveAnswer = (formFieldId: number, answer: boolean) => {
    return saveAnswerMutation({
      variables: { formId, formElementId: formFieldId, data: answer.toString() }
    });
  };

  const answers = data?.patientFormCompletion?.answers ?? [];
  const answerByFieldId = answers.reduce((acc, answer) => {
    if (answer) {
      acc[answer.formElementId] = answer.data === 'true';
    }
    return acc;
  }, {} as Record<string, boolean>);

  return { answerByFieldId, saveAnswer };
};
